import { styled } from '@mui/system';

export type PillVariant = 'primary' | 'secondary';
interface PillContainerProps {
  backgroundColor: string;
  color: string;
  variant: PillVariant;
}
export const PillContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'backgroundColor' && prop !== 'color' && prop !== 'variant',
})<PillContainerProps>(({ backgroundColor, color, variant }) => {
  const VARIANT = {
    backgroundColor: '',
    boxShadow: '',
  };

  switch (variant) {
    case 'secondary':
      VARIANT.boxShadow = `inset 0 0 0 1px ${backgroundColor}`;
      break;
    case 'primary':
    default:
      VARIANT.backgroundColor = backgroundColor;
  }

  return {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    columnGap: 4,
    color: color,
    height: 26,
    padding: '0 10px',
    fontSize: 12,
    fontWeight: 700,
    textTransform: 'uppercase',
    borderRadius: 6,
    ...VARIANT,
    '> svg': {
      width: 15,
      height: 15,
    },
  };
});
